import {useState} from 'react';
import {useDispatch} from 'react-redux';
import {UPDATE_EVENT_DETAILS} from '~/CreateFabricInvitation/reducers/details/constants';
import {SET_UPSELL_CONFIRMED} from '~/CreateFabricInvitation/reducers/modals';
import {
  webViewModalShowing,
  webViewPendingUpgradeToPremium,
} from '~/CreateFabricInvitation/webview/webview';
import {REVERT_TO_BASIC} from '~/CreateFabricInvitation/reducers/fabricDesign/constants';
import {removeOffer} from '~/CreateFabricInvitation/api/review';
import {setShowLeaveModal} from '~/CreateFabricInvitation/reducers/modals/actions';
import {Sections} from '~/CreateFabricInvitation/routes/EventCreateDesign/constants';

export const useHeaderModals = ({store, navigate, currentRoute, isPremium}) => {
  const dispatch = useDispatch();
  const [showUpsellModal, setShowUpsellModal] = useState(false);
  const [upsellModalMode, setUpsellModalMode] = useState('');
  const [showExitPremiumPreviewModal, setShowExitPremiumPreviewModal] = useState(false);

  const toggleUpsellModal = (changeToState, mode) => {
    if (changeToState) {
      webViewModalShowing('upsell');
    }
    setShowUpsellModal(changeToState);
    setUpsellModalMode(changeToState ? mode : '');
  };

  const downgradeIfDismissCheckout = () => {
    if (currentRoute.name === 'review' && isPremium) {
      removeOffer(store);
    }
  };

  const onClosePremiumPreviewClick = () => {
    setShowExitPremiumPreviewModal(true);
  };

  const upgradeToPremium = () => {
    store.dispatch({
      type: UPDATE_EVENT_DETAILS,
      payload: {isPremium: true, hideUpsell: true},
    });
    store.dispatch({
      type: SET_UPSELL_CONFIRMED,
      payload: true,
    });
    window.dataLayer.push({
      event: `fabric_create_upgrade_${currentRoute.name}`,
    });
    webViewPendingUpgradeToPremium(true);
    toggleUpsellModal(false);
  };

  const handleExitPremiumPreview = () => {
    store.dispatch({
      type: REVERT_TO_BASIC,
    });
    webViewPendingUpgradeToPremium(false);
    navigate(Sections.CARD_DESIGN);
    setShowExitPremiumPreviewModal(false);
  };

  const handleShowLeaveModal = () => {
    dispatch(setShowLeaveModal(true));
  };

  return {
    showUpsellModal,
    upsellModalMode,
    showExitPremiumPreviewModal,
    setShowUpsellModal,
    setShowExitPremiumPreviewModal,
    toggleUpsellModal,
    downgradeIfDismissCheckout,
    onClosePremiumPreviewClick,
    upgradeToPremium,
    handleExitPremiumPreview,
    handleShowLeaveModal,
  };
};
